export default __webpack_public_path__ + "img/404.b21ed084.png";